import type { TOC } from '@ember/component/template-only'
import Component from '@glimmer/component'
import { service } from '@ember/service'
import type SideNavService from 'teacher-ui-client/services/side-nav'
import { SubscriptionType } from 'teacher-ui-client/subscription-type/subscription-types'
import { eq } from 'ember-truth-helpers'
import { ManagementAccordion } from 'teacher-ui-client/components/side-nav/management-accordion'
import SideNavMathsHelpJuice from 'teacher-ui-client/components/side-nav/maths/help-juice'
import { ReadingTeacherToolkitAccordion } from 'teacher-ui-client/components/side-nav/reading/teacher-toolkit-accordion'
import { MathsTeacherToolkitAccordion } from 'teacher-ui-client/components/side-nav/maths/teacher-toolkit-accordion'
import WritingSideNavQuickLinksAccordion from 'teacher-ui-client/components/side-nav/writing/quick-links-accordion'
import ReadingSideNavQuickLinksAccordion from 'teacher-ui-client/components/side-nav/reading/quick-links-accordion'
import MathsSideNavQuickLinksAccordion from 'teacher-ui-client/components/side-nav/maths/quick-links-accordion'
import BookLibraryAccordion from 'teacher-ui-client/components/side-nav/reading/book-library-accordion'
import SideNavGroup from 'teacher-ui-client/components/side-nav/group'
import HomeSidenavLink from 'teacher-ui-client/components/side-nav/links/home'
import TeacherHomeSidenavLink from 'teacher-ui-client/components/side-nav/links/teacher-home'
import WhatsNewLink from 'teacher-ui-client/components/side-nav/links/whats-new'
import CatchUpGuidesLink from 'teacher-ui-client/components/side-nav/links/catch-up-guides'
import PrintablesLink from 'teacher-ui-client/components/side-nav/links/printables'
import AccountLink from 'teacher-ui-client/components/side-nav/links/account'
import ContactUsLink from 'teacher-ui-client/components/side-nav/links/contact-us'
import LogOutButton from 'teacher-ui-client/components/side-nav/links/log-out'
import QuickStartLink from 'teacher-ui-client/components/side-nav/links/quick-start'
import { ReadingEggsProductGroup } from 'teacher-ui-client/components/side-nav/reading/reading-eggs-product-group'
import { ReadingEggspressProductGroup } from 'teacher-ui-client/components/side-nav/reading/reading-eggspress-product-group'
import { FastPhonicsProductGroup } from 'teacher-ui-client/components/side-nav/reading/fast-phonics-product-group'
import { MathseedsProductGroup } from 'teacher-ui-client/components/side-nav/maths/mathseeds-product-group'
import { MathseedsPrimeProductGroup } from 'teacher-ui-client/components/side-nav/maths/mathseeds-prime-product-group'
import { WritingLegendsProductGroup } from 'teacher-ui-client/components/side-nav/writing/writing-legends-product-group'

export class SideNavForSubscription extends Component {
  @service sideNav!: SideNavService

  <template>
    <nav data-test-sidenav class="w-1/6 max-w-96 min-w-64 space-y-1 px-2 print:hidden" role="menu">
      {{#if (eq this.sideNav.currentSubscriptionType SubscriptionType.Reading)}}
        <ReadingSideNav />
      {{else if (eq this.sideNav.currentSubscriptionType SubscriptionType.Maths)}}
        <MathsSideNav />
      {{else if (eq this.sideNav.currentSubscriptionType SubscriptionType.Writing)}}
        <WritingSideNav />
      {{/if}}
    </nav>
  </template>
}

interface Signature {
  Element: HTMLElement
}

export const ReadingSideNav: TOC<Signature> = <template>
  <SideNavGroup>
    <HomeSidenavLink />
    <TeacherHomeSidenavLink />
    <QuickStartLink />
    <WhatsNewLink @featureFlag="tui_blog_posts" />
    <CatchUpGuidesLink />
    <ReadingTeacherToolkitAccordion />
    <PrintablesLink />
    <BookLibraryAccordion />
    <ManagementAccordion />
  </SideNavGroup>
  <ReadingEggsProductGroup />
  <ReadingEggspressProductGroup />
  <FastPhonicsProductGroup />
  <SideNavGroup>
    <ReadingSideNavQuickLinksAccordion />
    <ContactUsLink />
    <AccountLink />
    <LogOutButton />
  </SideNavGroup>
</template>

export const MathsSideNav: TOC<Signature> = <template>
  <SideNavGroup>
    <HomeSidenavLink />
    <TeacherHomeSidenavLink />
    <QuickStartLink />
    <WhatsNewLink @featureFlag="tui_blog_posts" />
    <MathsTeacherToolkitAccordion />
    <PrintablesLink />
    <ManagementAccordion />
  </SideNavGroup>
  <MathseedsProductGroup />
  <MathseedsPrimeProductGroup />
  <SideNavGroup>
    <MathsSideNavQuickLinksAccordion />
    <ContactUsLink />
    <AccountLink />
    <LogOutButton />
  </SideNavGroup>
  <SideNavMathsHelpJuice class="mx-auto my-3 w-4/5" />
</template>

export const WritingSideNav: TOC<Signature> = <template>
  <SideNavGroup>
    <HomeSidenavLink />
    <TeacherHomeSidenavLink />
    <QuickStartLink />
    <WhatsNewLink @featureFlag="tui_blog_posts" />
    <PrintablesLink />
    <ManagementAccordion />
  </SideNavGroup>
  <WritingLegendsProductGroup />
  <SideNavGroup>
    <WritingSideNavQuickLinksAccordion />
    <ContactUsLink />
    <AccountLink />
    <LogOutButton />
  </SideNavGroup>
</template>
